/* eslint-disable @typescript-eslint/no-explicit-any */
import { contentfulApi } from "lib/api";
import React, { useEffect, useState } from "react";

interface AssetLinkProps {
  linkTitle: string;
  asset?: any;
  isInverted?: boolean;
}

interface EntryLinkProps {
  node: any;
  isInverted: boolean;
}

interface PageLinkProps extends AssetLinkProps {
  slug: string;
}

const AssetLink = (props: AssetLinkProps) => {
  const { isInverted, asset, linkTitle } = props;
  const assetUrl = asset.file ? asset.file["en-NZ"]?.url : null;

  return (
    <a className={isInverted ? "link link_dark" : "link"} href={assetUrl}>
      {linkTitle || assetUrl}
    </a>
  );
};

const PageLink = (props: PageLinkProps) => {
  const { isInverted, slug, linkTitle } = props;
  return (
    <a href={`/${slug}/`} className={isInverted ? "link link_dark" : "link"}>
      {linkTitle || slug}
    </a>
  );
};

const EntryLink = (props: EntryLinkProps) => {
  const [page, setPage] = useState<any>(null);
  const { node, isInverted } = props;
  useEffect(
    () =>
      contentfulApi
        .getEntry(node.data.target.sys.id)
        .then((response: any) => setPage(response)),
    [node.data.target.sys.id],
  );
  return (
    page && (
      <PageLink
        linkTitle={node.content[0].value}
        slug={page.fields.slug}
        isInverted={isInverted}
      />
    )
  );
};

export { AssetLink, EntryLink, PageLink };
